import { useQuery } from '@tanstack/react-query';
import { getVideos } from '../services/admin/admin-video.service';
import { ADMIN_VIDEOS_KEY } from '../common/utils/video-query-cache';

export function useVideoPlacementUsage(key: string) {
  const query = { placement_key: key, limit: 1 };

  return useQuery({
    queryKey: [ADMIN_VIDEOS_KEY, query],
    queryFn: () => getVideos(query),
    select: (page) => page.total,
  });
}
